import store from './field-manager-store';
import routes from './field-manager-routes';

const components = [];
const mixins = [];
const filters = [];
const directives = [];

export default {
  components,
  mixins,
  filters,
  directives,
  routes,
  store
};



// WEBPACK FOOTER //
// ./src/entities/field-manager/field-manager-module.js